import React from 'react';
import './blog.scss';
import { Link } from 'react-router-dom';

const BlogCard = ({ blog }) => {
  return (
    <div className="blog-card">
      <img src={blog.imageUrl} className="blog-card--image" alt={blog.name} />
      <div className="blog-card--title ellipsis">{blog.name}</div>
      <div className="blog-card--description ellipsis">{blog.description}</div>
      {blog.isExternalBlog && (
        <a
          href={blog.actionUri}
          target="_blank"
          className="button action-link more"
        >
          READ MORE
        </a>
      )}
      {!blog.isExternalBlog && (
        <Link to={`${blog.actionUri}-bg`} className="button action-link more">
          READ MORE
        </Link>
      )}
    </div>
  );
};

export default BlogCard;
